import useCarouselManager from "marketingWebsite/utils/useCarouselManager.js"
import useFAQaccordion from "marketingWebsite/utils/useFAQaccordion.js"
import useIntercom from "marketingWebsite/utils/useIntercom.js"
import {
    useHighlighting,
    useYoutubeVideo
} from "marketingWebsite/techstack/index.js"

useYoutubeVideo()
useHighlighting()
useFAQaccordion()
useCarouselManager({
    carouselRoot: ".butter-carousel",
    nextControl: ".butter-carousel-control--next",
    prevControl: ".butter-carousel-control--prev",
    viewport: ".butter-carousel-viewport"
})
useIntercom()
